"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildUrl;
var _queryString = _interopRequireDefault(require("query-string"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// File copied from https://github.com/folio-org/stripes-smart-components/blob/master/lib/SearchAndSort/buildUrl.js

function removeEmpty(obj) {
  const cleanObj = {};
  (0, _lodash.forOwn)(obj, (value, key) => {
    if (value) cleanObj[key] = value;
  });
  return cleanObj;
}
function buildUrl(location, values, basePath) {
  var _location$query;
  const locationQuery = (_location$query = location === null || location === void 0 ? void 0 : location.query) !== null && _location$query !== void 0 ? _location$query : _queryString.default.parse(location.search);
  let url = values._path || basePath || location.pathname;
  const params = removeEmpty(Object.assign(locationQuery, values));
  (0, _lodash.unset)(params, '_path');
  if (!(0, _lodash.isEmpty)(params)) {
    url += "?".concat(_queryString.default.stringify(params));
  }
  return url;
}